/*
 * A <label>. Stacked above a control by default: we set no box dimensions, so it
 * inherits the theme's <label> — which in Limitless is identical to `.control-label`
 * (inline-block, 20px line-height, 7px bottom-margin, weight 400). That means a
 * standalone Label lines up with a Field.Label (and a Field.Label-as-legend)
 * automatically, with the same gap above the control.
 */
.root {
	cursor: pointer;
	user-select: none;
}

/*
 * When the label ENCLOSES its control — a checkbox/radio (Base UI span or a native
 * input) or a text input — lay it out as an inline row at the same control-to-text
 * gap as a checkbox/radio option, and drop the stacked bottom-margin/weight.
 */
.root:has(> input, > [data-slot="checkbox"], > [data-slot="radio-group-item"]) {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 0;
	font-weight: normal;
}

/*
 * An enclosed text input (checkbox/radio excluded — they keep their intrinsic size):
 * keep the label text on a single line and let the input take the remaining width,
 * so the text sits beside the input just like a checkbox label sits beside its box.
 */
.root:has(> input:not([type="checkbox"]):not([type="radio"])) {
	white-space: nowrap;
}

.root:has(> input:not([type="checkbox"]):not([type="radio"])) > input {
	flex: 1;
}

/* Limitless dims the whole disabled control at opacity 0.5. :has(:disabled) covers
   an enclosed control; [data-disabled] the Base UI sibling case. */
.root:has(:disabled),
.root[data-disabled] {
	cursor: not-allowed;
	opacity: 0.5;
}
